// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/images/ico/ico_remove.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/assets/images/ico/ico_calendar.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  padding-right: 0 !important;
}
.card-body {
  background-color: #fff;
  padding: 1.8rem 1.4rem;
}

.App {
  text-align: center;
}

.form-select {
  width: 168px;
  vertical-align: middle;
}
.full-select-box .form-select {
  width: 100%;
}

.from-group {
  display: flex;
}

.pagination {
  justify-content: center;
  width: 100%;
}
.test {
  background-color: #fff;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex-ai-center {
  display: flex;
  align-items: center;
}
.just-left {
  justify-content: left;
}
.just-center {
  justify-content: center;
  width: 60%;
}
.just-right {
  float: right;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.hide {
  display: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.table > :not(:first-child) {
  border-top: 1px solid #eaeaea;
}

table thead tr th {
  text-align: center;
}

.td-center {
  text-align: center;
}

.td-left {
  text-align: left;
}

.td-right {
  text-align: right;
}

.font-bold {
  font-weight: bold;
}

thead,
.table tbody tr th {
  background-color: #f5f5f5;
  color: #000;
}

.table.type02 thead th:first-of-type,
.table.type02 tbody tr th {
  border-right: 1px solid #eaeaea;
}

.table tbody tr td {
  background-color: #fff;
}

.table2:not(.modal-tbl) tbody tr {
  cursor: pointer;
}

.table.detail-tbl tr th,
.table.detail-tbl tr td {
  padding: 16px 10px;
  align-items: center;
}

.table.detail-tbl .img-box .img {
  display: block;
  width: 150px;
  height: 150px;
}

.table.detail-tbl .img-box {
  position: relative;
}

.table.detail-tbl .img-box .remove-btn {
  width: 20px;
  height: 20px;
  padding: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / contain;
  border: none;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(45%, -45%);
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.contentArea {
  width: 100%;
  max-width: none;
  background-color: #ecf4fb;
}

/* .sidebarArea .sidenav-bg .active {
  background-color: #26c6da;
} */

h4 {
  margin: 20px 0 20px;
}

.noline_r {
  border-width: 0 0 !important;
  border-right: none;
  border-style: none !important;
}
.noline_l {
  border-left: none;
}

input[type='radio'] {
  margin-right: 4px;
}

#radioDiv .btn {
  margin-bottom: 0 !important;
}

.sidebarArea .sidenav-bg .active {
  background-color: #26c6da;
}

.nav-tabs .nav-item {
  margin-bottom: -1px;
}

.nav-tabs-primary .nav.nav-tabs .nav-item .nav-link.active {
  color: #3c44b1;
  border-top: 3px solid #3c44b1;
}

.nav.nav-tabs .nav-item .nav-link.active {
  margin-top: 0;
  color: #3c44b1;
  background: transparent;
  border-top: 3px solid #3c44b1;
}

.nav.nav-tabs .nav-item .nav-link {
  /* font-size: .875rem; */
  text-transform: uppercase;
  margin: 2px 0 0;
  color: #a6a6b9;
  background: transparent;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

.page-item.active .page-link {
  background-color: #20a8b9;
  border-color: #20a8b9;
}

.page-link {
  color: black;
}

.input-datepicker {
  display: inline-block;
  width: 164px;
  padding: 0.375rem 0.75rem;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.box-wrap {
  justify-content: flex-start;
  display: inline-flex;
}

.codeTr {
  cursor: pointer;
}
.codeTr:hover {
  background: #a6a6b9;
}

.codeTr:active {
  background: #a6a6b9;
}

.formHide {
  display: none;
}

.formShow {
  display: block;
}

.margin-right {
  margin-right: 4px;
}

.margin-right2 {
  margin-right: 20px;
}

.like-link {
  text-decoration: underline;
  text-underline-position: under;
  color: #0a18e9;
  cursor: pointer;
}

/* .cancel_btn {
  background: #6b6b6b;
  border: none;
  border-color :#6b6b6b;
} */

.btn_noneborder {
  border: none;
}

.total-cnt,
.-cnt {
  color: #63c0f7;
  font-weight: bold;
}

/* color */
.color-light {
  color: #b2b2b2 !important;
}

/* clean-modal */
.modal-title {
  font-weight: 600;
  font-size: 18px;
}
.modal-sch-box {
  gap: 5px;
  width: 100%;
  padding: 20px 0 40px;
}
.modal-sch-box input {
  width: calc(100% - 100px);
  height: 40px;
  border-radius: 0.3rem;
  border: 1px solid #dee2e6;
}
.modal-sch-box button {
  width: 100px;
  height: 40px;
}
.modal-footer {
  gap: 4px;
}
.modal-footer button {
  margin: 0;
}

/* form-control */
.form-control-wrap {
  padding: 0.5rem !important;
}
.form-control-wrap input {
  color: #666;
}

/* datepicker css */
.react-datepicker__navigation--previous,
.react-datepicker__navigation--next {
  top: 6px !important;
}

/* calendar css */
.react-calendar {
  width: 100% !important;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.4) !important;
  border: 1px solid #dee3e4 !important;
  border-radius: 15px;
  font-family: inherit !important;
  list-style: none;
}
.react-calendar__navigation button {
  font-weight: 700;
  font-size: 18px;
  color: #444;
}
.react-calendar__navigation__arrow {
  font-size: 2px;
  color: #555 !important;
}
abbr[title] {
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  color: #222;
  line-height: 2.8;
}
.react-calendar__month-view__days__day {
  border-radius: 5px;
  font-size: 15px;
  color: #2b2b2b;
}
.react-calendar__tile--active,
.react-calendar__tile--now.react-calendar__tile--active {
  background-color: #26c6da !important;
  border-radius: 5px;
  font-weight: 500;
}
.react-calendar__tile--now {
  background-color: transparent !important;
  border: 1px solid #26c5dadc !important;
  border-radius: 5px;
}
.react-calendar__month-view__days__day--weekend {
  color: rgba(222, 40, 64, 0.91) !important;
}
.react-calendar__month-view__days__day--neighboringMonth {
  color: #bbb !important;
}

/* 청소등록이력요청 */
.url-wrapper {
  /* max-width: 375px; */
  width: 100%;
  height: 100vh;
  margin: auto;

  background-color: #fff;
}
.url-container {
  margin: 0 1rem;
}
.url-header {
  padding: 0.74rem 0;
  margin-bottom: 2rem;
  border-bottom: 0.05rem solid rgba(75, 78, 89, 0.327);
  text-align: center;
  position: relative;
}
.url.login .url-header {
  margin-bottom: 2.8rem;
}
.url-header button {
  padding: 0;
  background-color: transparent;
  border: none;
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
}
.url-header button i {
  font-size: 1.2rem;
}
.url-header h1 {
  margin-bottom: 0;
  font-weight: 600;
  font-size: 1.1rem;
}
.url.login .tf {
  margin-bottom: 0.4rem;
  height: 2.8rem;
}
.url.login .log-btn {
  width: 100%;
  height: 2.8rem;
}
.url.register .no-list {
  color: #b2b2b2;
  text-align: center;
}
.url.register .list {
  padding: 1rem 0.5rem 1.8rem;
  margin: 0 1.2rem 2rem;
  border-bottom: 0.05rem solid #e1e2f0ca;
  position: relative;
}
.url.register .list .flex-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.url.register .list h2 {
  margin-bottom: 0.2rem;
  font-weight: 500;
  font-size: 1.1rem;
}
.url.register .list p {
  margin-bottom: 0;
  font-weight: 500;
  font-size: 0.9rem;
  color: #26c6da;
}
.url.register .list .add-btn {
  align-self: flex-end;
}
.url.register .date-list {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-top: 2.4rem;
  margin-bottom: 0;
}
.url.register .date-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 0.9rem;
  color: #b2b2b2;
  list-style: none;
}
.url.register .date-list li:not(:last-of-type) {
  margin-bottom: 0.4rem;
}
.url.register .date-list li button {
  padding: 0;
  background-color: transparent;
  border: none;
  font-weight: 500;
  font-size: 1rem;
  color: #2962ff;
  position: relative;
}
.url.register .date-list li button::after {
  content: '';
  display: block;
  width: 100%;
  height: 0.05rem;
  background-color: #2962ff;
  position: absolute;
  bottom: 0.14rem;
  left: 0;
}
.url.history th {
  font-size: 0.92rem;
  line-height: 1.2;
  letter-spacing: -0.019rem;
}
.url.history .input-datepicker {
  width: 100%;
  font-size: 0.9rem;
  color: var(--bs-body-color);
}
.url.history textarea {
  resize: none;
  display: block;
  width: 100%;
  height: 5rem;
  padding: 0.375rem 0.75rem;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  font-size: 0.9rem;
  color: var(--bs-body-color);
  line-height: 1.4;
}
.url.history textarea::placeholder {
  color: #b2b2b2;
}
.url.history .desc {
  font-size: 0.9rem;
  color: #777;
}
.url.history .add-img {
  margin-bottom: 1rem;
  font-size: 0.85rem;
  padding: 0.2rem 0.4rem !important;
}
.url.history .flex-box {
  flex-wrap: wrap;
  gap: 0.7rem;
}
.url.history .img-box {
  display: block;
  width: calc((100% - 1.4rem) / 3);
  height: 3.7rem;
  background-color: rgb(234, 237, 240);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: relative;
}
.url.history .img-box .img {
  display: block;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.url.history .remove-btn {
  padding: 0;
  background-color: transparent;
  border: none;
  position: absolute;
  top: -0.55rem;
  right: -0.45rem;
}

.url.detail dl {
  margin-bottom: 2em;
}
.url.detail dt {
  margin-bottom: 0.75rem;
  font-weight: 700;
  font-size: 0.95rem;
}
.url.detail dd {
  font-size: 0.95rem;
  color: #555;
}
.url.detail dd .cover {
  width: calc((100% - 1.2rem) / 4);
  height: 4.5rem;
}
.url.detail dd .img-box {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.url.preview .img-box {
  width: 100%;
  height: calc(100vh - 9.5rem);
  overflow: hidden;
}
.url.preview .img-box img {
  width: 100%;
  height: auto;
}

/* input - type="number" 화살표 제거 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}

/* calendar button */
.calendar-btn {
  width: 38px;
  height: 38px;
  background: #f9f9f9 url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 54%;
  border: 1px solid #ddd;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,8EAAsF;EACtF,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;;;;GAIG;;AAEH;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,QAAQ;EACR,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,QAAQ;AACV;AACA;EACE,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB;;EAEE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,aAAa;EACb,qDAAqD;EACrD,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,YAAY;;EAEZ,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;EACpD,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,2DAA2D;EAC3D,sCAAsC;EACtC,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,cAAc;EACd,oCAAoC;EACpC,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iCAAiC;AACjC;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,kFAA4F;EAC5F,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":["body {\n  padding-right: 0 !important;\n}\n.card-body {\n  background-color: #fff;\n  padding: 1.8rem 1.4rem;\n}\n\n.App {\n  text-align: center;\n}\n\n.form-select {\n  width: 168px;\n  vertical-align: middle;\n}\n.full-select-box .form-select {\n  width: 100%;\n}\n\n.from-group {\n  display: flex;\n}\n\n.pagination {\n  justify-content: center;\n  width: 100%;\n}\n.test {\n  background-color: #fff;\n}\n\n.flex-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.flex-ai-center {\n  display: flex;\n  align-items: center;\n}\n.just-left {\n  justify-content: left;\n}\n.just-center {\n  justify-content: center;\n  width: 60%;\n}\n.just-right {\n  float: right;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.hide {\n  display: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.table > :not(:first-child) {\n  border-top: 1px solid #eaeaea;\n}\n\ntable thead tr th {\n  text-align: center;\n}\n\n.td-center {\n  text-align: center;\n}\n\n.td-left {\n  text-align: left;\n}\n\n.td-right {\n  text-align: right;\n}\n\n.font-bold {\n  font-weight: bold;\n}\n\nthead,\n.table tbody tr th {\n  background-color: #f5f5f5;\n  color: #000;\n}\n\n.table.type02 thead th:first-of-type,\n.table.type02 tbody tr th {\n  border-right: 1px solid #eaeaea;\n}\n\n.table tbody tr td {\n  background-color: #fff;\n}\n\n.table2:not(.modal-tbl) tbody tr {\n  cursor: pointer;\n}\n\n.table.detail-tbl tr th,\n.table.detail-tbl tr td {\n  padding: 16px 10px;\n  align-items: center;\n}\n\n.table.detail-tbl .img-box .img {\n  display: block;\n  width: 150px;\n  height: 150px;\n}\n\n.table.detail-tbl .img-box {\n  position: relative;\n}\n\n.table.detail-tbl .img-box .remove-btn {\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  background: url('/public/assets/images/ico/ico_remove.png') no-repeat center / contain;\n  border: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate(45%, -45%);\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.contentArea {\n  width: 100%;\n  max-width: none;\n  background-color: #ecf4fb;\n}\n\n/* .sidebarArea .sidenav-bg .active {\n  background-color: #26c6da;\n} */\n\nh4 {\n  margin: 20px 0 20px;\n}\n\n.noline_r {\n  border-width: 0 0 !important;\n  border-right: none;\n  border-style: none !important;\n}\n.noline_l {\n  border-left: none;\n}\n\ninput[type='radio'] {\n  margin-right: 4px;\n}\n\n#radioDiv .btn {\n  margin-bottom: 0 !important;\n}\n\n.sidebarArea .sidenav-bg .active {\n  background-color: #26c6da;\n}\n\n.nav-tabs .nav-item {\n  margin-bottom: -1px;\n}\n\n.nav-tabs-primary .nav.nav-tabs .nav-item .nav-link.active {\n  color: #3c44b1;\n  border-top: 3px solid #3c44b1;\n}\n\n.nav.nav-tabs .nav-item .nav-link.active {\n  margin-top: 0;\n  color: #3c44b1;\n  background: transparent;\n  border-top: 3px solid #3c44b1;\n}\n\n.nav.nav-tabs .nav-item .nav-link {\n  /* font-size: .875rem; */\n  text-transform: uppercase;\n  margin: 2px 0 0;\n  color: #a6a6b9;\n  background: transparent;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n}\n\n.page-item.active .page-link {\n  background-color: #20a8b9;\n  border-color: #20a8b9;\n}\n\n.page-link {\n  color: black;\n}\n\n.input-datepicker {\n  display: inline-block;\n  width: 164px;\n  padding: 0.375rem 0.75rem;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n}\n\n.box-wrap {\n  justify-content: flex-start;\n  display: inline-flex;\n}\n\n.codeTr {\n  cursor: pointer;\n}\n.codeTr:hover {\n  background: #a6a6b9;\n}\n\n.codeTr:active {\n  background: #a6a6b9;\n}\n\n.formHide {\n  display: none;\n}\n\n.formShow {\n  display: block;\n}\n\n.margin-right {\n  margin-right: 4px;\n}\n\n.margin-right2 {\n  margin-right: 20px;\n}\n\n.like-link {\n  text-decoration: underline;\n  text-underline-position: under;\n  color: #0a18e9;\n  cursor: pointer;\n}\n\n/* .cancel_btn {\n  background: #6b6b6b;\n  border: none;\n  border-color :#6b6b6b;\n} */\n\n.btn_noneborder {\n  border: none;\n}\n\n.total-cnt,\n.-cnt {\n  color: #63c0f7;\n  font-weight: bold;\n}\n\n/* color */\n.color-light {\n  color: #b2b2b2 !important;\n}\n\n/* clean-modal */\n.modal-title {\n  font-weight: 600;\n  font-size: 18px;\n}\n.modal-sch-box {\n  gap: 5px;\n  width: 100%;\n  padding: 20px 0 40px;\n}\n.modal-sch-box input {\n  width: calc(100% - 100px);\n  height: 40px;\n  border-radius: 0.3rem;\n  border: 1px solid #dee2e6;\n}\n.modal-sch-box button {\n  width: 100px;\n  height: 40px;\n}\n.modal-footer {\n  gap: 4px;\n}\n.modal-footer button {\n  margin: 0;\n}\n\n/* form-control */\n.form-control-wrap {\n  padding: 0.5rem !important;\n}\n.form-control-wrap input {\n  color: #666;\n}\n\n/* datepicker css */\n.react-datepicker__navigation--previous,\n.react-datepicker__navigation--next {\n  top: 6px !important;\n}\n\n/* calendar css */\n.react-calendar {\n  width: 100% !important;\n  padding: 10px;\n  background-color: rgba(255, 255, 255, 0.4) !important;\n  border: 1px solid #dee3e4 !important;\n  border-radius: 15px;\n  font-family: inherit !important;\n  list-style: none;\n}\n.react-calendar__navigation button {\n  font-weight: 700;\n  font-size: 18px;\n  color: #444;\n}\n.react-calendar__navigation__arrow {\n  font-size: 2px;\n  color: #555 !important;\n}\nabbr[title] {\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 14px;\n  color: #222;\n  line-height: 2.8;\n}\n.react-calendar__month-view__days__day {\n  border-radius: 5px;\n  font-size: 15px;\n  color: #2b2b2b;\n}\n.react-calendar__tile--active,\n.react-calendar__tile--now.react-calendar__tile--active {\n  background-color: #26c6da !important;\n  border-radius: 5px;\n  font-weight: 500;\n}\n.react-calendar__tile--now {\n  background-color: transparent !important;\n  border: 1px solid #26c5dadc !important;\n  border-radius: 5px;\n}\n.react-calendar__month-view__days__day--weekend {\n  color: rgba(222, 40, 64, 0.91) !important;\n}\n.react-calendar__month-view__days__day--neighboringMonth {\n  color: #bbb !important;\n}\n\n/* 청소등록이력요청 */\n.url-wrapper {\n  /* max-width: 375px; */\n  width: 100%;\n  height: 100vh;\n  margin: auto;\n\n  background-color: #fff;\n}\n.url-container {\n  margin: 0 1rem;\n}\n.url-header {\n  padding: 0.74rem 0;\n  margin-bottom: 2rem;\n  border-bottom: 0.05rem solid rgba(75, 78, 89, 0.327);\n  text-align: center;\n  position: relative;\n}\n.url.login .url-header {\n  margin-bottom: 2.8rem;\n}\n.url-header button {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  position: absolute;\n  top: 50%;\n  right: 1rem;\n  transform: translateY(-50%);\n}\n.url-header button i {\n  font-size: 1.2rem;\n}\n.url-header h1 {\n  margin-bottom: 0;\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n.url.login .tf {\n  margin-bottom: 0.4rem;\n  height: 2.8rem;\n}\n.url.login .log-btn {\n  width: 100%;\n  height: 2.8rem;\n}\n.url.register .no-list {\n  color: #b2b2b2;\n  text-align: center;\n}\n.url.register .list {\n  padding: 1rem 0.5rem 1.8rem;\n  margin: 0 1.2rem 2rem;\n  border-bottom: 0.05rem solid #e1e2f0ca;\n  position: relative;\n}\n.url.register .list .flex-box {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.url.register .list h2 {\n  margin-bottom: 0.2rem;\n  font-weight: 500;\n  font-size: 1.1rem;\n}\n.url.register .list p {\n  margin-bottom: 0;\n  font-weight: 500;\n  font-size: 0.9rem;\n  color: #26c6da;\n}\n.url.register .list .add-btn {\n  align-self: flex-end;\n}\n.url.register .date-list {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-top: 2.4rem;\n  margin-bottom: 0;\n}\n.url.register .date-list li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  font-size: 0.9rem;\n  color: #b2b2b2;\n  list-style: none;\n}\n.url.register .date-list li:not(:last-of-type) {\n  margin-bottom: 0.4rem;\n}\n.url.register .date-list li button {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  font-weight: 500;\n  font-size: 1rem;\n  color: #2962ff;\n  position: relative;\n}\n.url.register .date-list li button::after {\n  content: '';\n  display: block;\n  width: 100%;\n  height: 0.05rem;\n  background-color: #2962ff;\n  position: absolute;\n  bottom: 0.14rem;\n  left: 0;\n}\n.url.history th {\n  font-size: 0.92rem;\n  line-height: 1.2;\n  letter-spacing: -0.019rem;\n}\n.url.history .input-datepicker {\n  width: 100%;\n  font-size: 0.9rem;\n  color: var(--bs-body-color);\n}\n.url.history textarea {\n  resize: none;\n  display: block;\n  width: 100%;\n  height: 5rem;\n  padding: 0.375rem 0.75rem;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  font-size: 0.9rem;\n  color: var(--bs-body-color);\n  line-height: 1.4;\n}\n.url.history textarea::placeholder {\n  color: #b2b2b2;\n}\n.url.history .desc {\n  font-size: 0.9rem;\n  color: #777;\n}\n.url.history .add-img {\n  margin-bottom: 1rem;\n  font-size: 0.85rem;\n  padding: 0.2rem 0.4rem !important;\n}\n.url.history .flex-box {\n  flex-wrap: wrap;\n  gap: 0.7rem;\n}\n.url.history .img-box {\n  display: block;\n  width: calc((100% - 1.4rem) / 3);\n  height: 3.7rem;\n  background-color: rgb(234, 237, 240);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  position: relative;\n}\n.url.history .img-box .img {\n  display: block;\n  width: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n.url.history .remove-btn {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  position: absolute;\n  top: -0.55rem;\n  right: -0.45rem;\n}\n\n.url.detail dl {\n  margin-bottom: 2em;\n}\n.url.detail dt {\n  margin-bottom: 0.75rem;\n  font-weight: 700;\n  font-size: 0.95rem;\n}\n.url.detail dd {\n  font-size: 0.95rem;\n  color: #555;\n}\n.url.detail dd .cover {\n  width: calc((100% - 1.2rem) / 4);\n  height: 4.5rem;\n}\n.url.detail dd .img-box {\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n\n.url.preview .img-box {\n  width: 100%;\n  height: calc(100vh - 9.5rem);\n  overflow: hidden;\n}\n.url.preview .img-box img {\n  width: 100%;\n  height: auto;\n}\n\n/* input - type=\"number\" 화살표 제거 */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n\n/* calendar button */\n.calendar-btn {\n  width: 38px;\n  height: 38px;\n  background: #f9f9f9 url('/public/assets/images/ico/ico_calendar.png') no-repeat center / 54%;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
